module.exports = __webpack_public_path__ + "assets/img/linux.39f61c7d.svg";